import styled from "@emotion/styled";
import Colors from "/styles/colors";
export const StyledTemplateBenefits = styled.div`
  color: ${Colors["mud"]};
  display: flex;
  flex-direction: column;

  &.align-center {
    align-items: center;

    .template-benefits-main-title {
      text-align: center;
    }
  }

  .template-benefits-main-title {
    font-weight: 700;
    font-size: 1rem;
    line-height: 24px;
  }

  .template-benefit-wrapper {
    margin-top: 32px;
  }
`;
